import { render } from "./CorporateHome.vue?vue&type=template&id=2ba76b7c&scoped=true"
import script from "./CorporateHome.vue?vue&type=script&lang=js"
export * from "./CorporateHome.vue?vue&type=script&lang=js"

import "./CorporateHome.vue?vue&type=style&index=0&id=2ba76b7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba76b7c"]])

export default __exports__